import { createApi } from "@reduxjs/toolkit/query/react";
import { buildBaseQuery } from "@app/api";
import { FilterParams } from "types";

import { IFaq, FaqCreationPayload } from "../types/index";

export const faqApi = createApi({
  reducerPath: "faqApi",
  baseQuery: buildBaseQuery(""),
  endpoints: (builder) => ({
    getFaqs: builder.query<{ faqs: IFaq[]; count: number}, Partial<FilterParams>>({
      query: (params) => {
        const queryString = Object.entries(params)
          .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
          .join('&');

        return `/faqs/dashboard?${queryString}`;
      },
    }),
    getFaqById: builder.query<IFaq, string>({
      query: (faqId) => `/faqs/${faqId}`,
    }),
    createFaq: builder.mutation<void, FaqCreationPayload>({
      query: (body) => ({
        url: "/faqs",
        method: "POST",
        body,
      }),
    }),
    updateFaqOrdering: builder.mutation<void, { ids: string[] }>({
      query: (body) => ({
        url: `/faqs/update-ordering`,
        method: "PATCH",
        body,
      }),
    }),
    updateFaq: builder.mutation<void, {id: string; body: FaqCreationPayload}>({
      query: ({ id, body }) => ({
        url: `/faqs/${id}`,
        method: "PATCH",
        body,
      }),
    }),
    deleteFaq: builder.mutation<void, { id: string }>({
      query: ({ id }) => ({
        url: `/faqs/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetFaqsQuery,
  useLazyGetFaqsQuery,
  useDeleteFaqMutation,
  useCreateFaqMutation,
  useUpdateFaqMutation,
  useLazyGetFaqByIdQuery,
  useUpdateFaqOrderingMutation,
} = faqApi;
